<div *ngIf="rating" class="star-ratings">
  <div [ngStyle]="{width: ((2 * rating) * 10) + '%'}" class="fill-ratings">
    <span>★★★★★</span>
  </div>
  <div class="empty-ratings">
    <span>★★★★★</span>
  </div>
</div>
